import React from "react";
import InputTitleClaroSocio from '../../molecules/InputTitleClaroSocio';
import styled from 'styled-components';
import ClaroParagraph from '../../atoms/ClaroParagraph'
import { reducer } from "redux-form";
import { connect } from "react-redux";

const Container = styled.div`
    background: #fff;
`;

const ContainerChips = styled.div`
    width:auto;
    height:auto;
    overflow:scroll;
    white-space: nowrap;
    text-align: center;
    margin: ${props => props.margin};
    padding: ${props => props.padding};
    max-width: initial;
    padding: 12px 0px;
`;

const ButtonMB = styled.button`
    background-color: #254aa5;
    border: none;
    color: white;
    padding: 9px 5px;
    font-size: 8px;
    font-weight: bold;
    border-radius: 50%;
    margin: -6px 0px -0px -18px;
    float: right;
    position: relative;
  `;

const ContainerDetailMB = styled.div`
    background: #fff;
    border: none;
    border-radius: 5px;
    width: 50%;
    padding: 3% 2%;
    margin: -2% auto -5%;
    text-align: center;
    font-size: 12px;
    box-shadow: 0 2px 12px #ccc;
    position: relative;
    z-index: 2;
    display: ${props => props.detailMbVisible? "block": "none" };
    animation: fadeinout 4s linear 1 forwards;
    @keyframes fadeinout {
        0% { opacity: 0; }
        20% { opacity: 1; }
        80% { opacity: 1; }
        100% { opacity: 0; }
    }
    font-family: ${props => props.fontFamily};
`;

const SrOnly = styled.span`
	position: absolute;
	width: 1px;
	height: 1px;
	margin: -1px;
	padding: 0;
	overflow: hidden;
	clip: rect(0, 0, 0, 0);
	border: 0;
`;
class ClaroChipsBlock extends React.Component {

    constructor(props){
        super(props)
        this.state = {
            detailMbVisible : false,
            mb: 0
        }
    }

    componentDidMount() {
        console.log(!this.props.appSyncValues.banks[0].toggles.SHOW_MEGAS_GIFT_CARD, "xdxd")
        setInterval(function() {
            this.setState({detailMbVisible: false})
        }.bind(this), 5000);
    }

    handleOnClick = (e, mb, hasPromotion, inputType, cost, idExternal) => {
        if(hasPromotion && !this.props.isContainerTelcel){
            this.setState({detailMbVisible: true, mb:mb})
        }
        this.props.handleInputClick(e, inputType, [], cost, idExternal)
    }

    render(){

        let { 
            input, 
            planInformationQuery, 
            isContainerTelcel,  
            creditCardInfo,
            appSyncValues
        } = this.props;

        if(planInformationQuery){
            return(
                <Container>
                    {
                        (this.props.planInformationQuery)?<ContainerDetailMB detailMbVisible={this.state.detailMbVisible} fontFamily="AMX-Regular">
                            Obtén <span style={{color:"blue", fontWeight:"bold"}}>{this.state.mb} Megas</span> de regalo
                        </ContainerDetailMB>:<></>
                    }
                    
                    <ClaroParagraph 
                        {...input.title.titleStyle} 
                        fontSize= {input.title.fontSize}
                        fontFamily={isContainerTelcel ? "AMX-Bold" : undefined}
                        margin={isContainerTelcel ? '0px 0.5em 0px 0.5em' : '0.5em'}
                    >
                        {input.title.text}
                    </ClaroParagraph>
                    
                    <ContainerChips
                        margin={isContainerTelcel ? "0px 2% 0px 2% !important" : "auto 2%"}
                        padding={isContainerTelcel ? "12px 0px 0px 0px !important" : "12px 0px"}
                        id={"content-chips"}
                    >
                        {
                            this.props.plans.detail.map((item, key) => {
                                let widhtConfigField = input.field.width? input.field.width: "70px";
                                let toolTipLbl = (item.hasPromotion)?item.promotion.toolTipLbl:"";
                                return <>
                                    <div 
                                        style={{
                                            "display": "inline-Block"
                                        }}
                                        id={item.amount}
                                    >
                                        {
                                            !isContainerTelcel 
                                            ?
                                                <>
                                                    <a 
                                                        style={{width: widhtConfigField}} 
                                                        type="select-chips" 
                                                        className={this.props.selectedItemId !== item.idExternal ? "chip" : "chip-selected"} 
                                                        key={key}
                                                        onClick= {(e) => this.handleOnClick(
                                                                e, 
                                                                toolTipLbl, 
                                                                item.hasPromotion,
                                                                input.type, 
                                                                item.cost, 
                                                                item.idExternal
                                                            )}
                                                    >
                                                        {"$"+ item.cost}
                                                    </a>
                                                    {(item.hasPromotion)?<ButtonMB onClick={ (e) => this.handleOnClick(e, toolTipLbl, item.hasPromotion )}>+MB</ButtonMB>:<></>}
                                                </>
                                            :
                                                <>
                                                    <a 
                                                        style={{width: widhtConfigField, position: "relative", marginBottom: "15px"}} 
                                                        type="select-chips" 
                                                        className={this.props.selectedItemId !== item.idExternal ? "chip-container-telcel" : "chip-container-telcel-selected"} 
                                                        key={key}
                                                        onClick= {(e) => this.handleOnClick(
                                                                e, 
                                                                toolTipLbl, 
                                                                item.hasPromotion,
                                                                input.type, 
                                                                item.cost, 
                                                                item.idExternal
                                                            )}
                                                    >
                                                        <span style={{ display: 'block' }}>
                                                            <span aria-hidden="true">$</span>{item.cost} 
                                                            <SrOnly>Pesos</SrOnly>
                                                        </span>

                                                        {
                                                            
                                                            item.promotions && 
                                                            item.promotions.PromotionMegasGift &&
                                                            appSyncValues &&
                                                            appSyncValues.banks &&
                                                            appSyncValues.banks[0] &&
                                                            appSyncValues.banks[0].toggles 
                                                            ? <img src={ item.promotions.PromotionMegasGift } style={{ width: "90%", position: "absolute", left: "5%", top: "77%" }} />
                                                            : <></>
                                                        }
                                                    </a>
                                                </>
                                        }
                                        

                                    </div></>
                            })
                        }
                    </ContainerChips>
                </Container>
            )
        } else {
            return(
                <Container>
                    <ClaroParagraph 
                        {...input.title.titleStyle} 
                        fontSize= {input.title.fontSize}
                        fontFamily={isContainerTelcel ? "AMX-Bold" : undefined}
                        margin={isContainerTelcel ? '0px 0.5em 0px 0.5em' : '0.5em'}
                    >
                        {input.title.text}
                    </ClaroParagraph>
                    <ContainerChips margin={isContainerTelcel ? "0px 2% 0px 2% !important" : "auto 2%"} padding={isContainerTelcel ? "12px 0px 0px 0px !important" : "12px 0px"}>
                        {
                            input.field.itemsList.map((item, key) => {
                                let widhtConfigField = input.field.width? input.field.width: "70px";
                                return (                                   
                                    !isContainerTelcel ? 
                                    <a 
                                        style={{width: widhtConfigField}} 
                                        type="select-chips" 
                                        className={this.props.selectedItemId !== item.productID ? "chip" : "chip-selected"} 
                                        key={key}
                                        onClick= {(e) => this.props.handleInputClick(e, input.type, [], item.amount, item.productID)}
                                    >
                                        {item.label}
                                    </a> : 
                                    <a 
                                        style={{width: widhtConfigField}} 
                                        type="select-chips" 
                                        className={this.props.selectedItemId !== item.productID ? "chip-container-telcel" : "chip-container-telcel-selected"} 
                                        key={key}
                                        onClick= {(e) => this.props.handleInputClick(e, input.type, [], item.amount, item.productID)}
                                    >
                                        {item.label}
                                    </a>
                                )
                            })
                        }
                    </ContainerChips>
                </Container>
            )
        }
    }

}

function mapStateToProps(state) {
    const { payments } = state;
    return {
        appSyncValues: payments.appSyncValues
    }
}

ClaroChipsBlock = connect(mapStateToProps)(ClaroChipsBlock);
export default ClaroChipsBlock;